<p class="nova-body-14">
  @for (part of messageParts(); track $index) {
    @if (part.type === "text") {
      <span>{{ part.content }}</span>
    } @else if (part.type === "link") {
      <a
        class="nova-link"
        appTrackedLink
        [trackId]="`legal-acknowledgements:${part.linkType}`"
        [routerLink]="getAcknowledgementRoute(part.linkType!)"
        queryParamsHandling="preserve"
        target="_blank"
        rel="noopener noreferrer"
        >{{ part.content }}</a
      >
    }
  }
</p>
